/**
 * Текст ошибки на экране входа.
 *
 * Раньше любая ошибка, кроме 429, показывалась как «Неверный email или пароль».
 * 15.09.2026 при сетевом сбое у сервера запрос до него не доходил, а сотрудник
 * видел «неверный пароль» и шёл его менять. Теперь нет ответа и 5xx — отдельные
 * тексты; неверный пароль — только когда сервер действительно ответил отказом.
 */
export function loginErrorMessage(e: unknown): string {
  const response = (
    e as {
      response?: { status?: number; data?: { error?: { code?: string; message?: string } } }
    } | null
  )?.response
  const status = response?.status
  // Нет ответа сервера: нет сети, таймаут, сервер недоступен по сети.
  if (status === undefined) {
    return 'Нет связи с сервером. Проверьте интернет или VPN и попробуйте снова.'
  }
  // Много неверных паролей — вход в аккаунт закрыт на время; сервер называет, на сколько.
  if (status === 429 && response?.data?.error?.code === 'LOGIN_LOCKED') {
    return response.data.error.message || 'Слишком много неверных попыток входа. Попробуйте позже.'
  }
  // 429 — сработал лимит попыток входа: человек с верным паролем должен просто подождать.
  if (status === 429) return 'Слишком много попыток входа. Подождите минуту и попробуйте снова.'
  // 5xx — сервер отвечает, но не может обработать вход (например, перезапуск при выкате).
  if (status >= 500) return 'Сервер временно недоступен, попробуйте через минуту.'
  // Заблокированный аккаунт — показываем причину, чтобы сотрудник не менял пароль зря.
  if (status === 401 && response?.data?.error?.code === 'ACCOUNT_BLOCKED') {
    return response.data.error.message || 'Аккаунт заблокирован. Обратитесь к администратору.'
  }
  return 'Неверный email или пароль'
}
